import React, { useContext } from 'react';
export class I18nImpl {
    _data;
    _language;
    constructor(data, language) {
        this._data = data;
        this._language = language;
    }
    translate(key) {
        return this.translateWithLang(key, this._language);
    }
    translateWithLang(key, language) {
        return this._data[language][key] || key;
    }
}
export const defaultLokalisointi = { fi: {}, sv: {}, en: {} };
export const LanguageContext = React.createContext({
    language: 'fi',
    i18n: new I18nImpl(defaultLokalisointi, 'fi'),
});
export const useLanguageContext = () => {
    const context = useContext(LanguageContext);
    if (!context && context !== null) {
        throw new Error('Localization not available');
    }
    return context;
};
